import React, { useEffect, useState } from "react";
import DashboardLayout from "../layout/Dashboard";
import { FormattedMessage } from "react-intl";
import { getTicketDetails as getTicketDetailsApi } from "../../api/clients/tickets";
import { Messages } from "../../components/layout/Messages/Messages";
import { ROUTE_CLIENT_TICKETS } from "../../config/routes";
import { history } from "../../store/configureStore";
import {
   NOTIFICATION_TICKETS_ACTIONS,
   NOTIFICATION_VIEW_TICKET
} from '../../config/notifications';
import { ACL, PAGE_CONTEXTS, TICKET_TYPES } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { ConfirmDeleteOrganizationTicket } from '../../components/pages/tickets/table/actionButtons/ConfirmDeleteOrganizationTicket';
import {
  TicketDetailsComponent
} from '../../components/pages/tickets/TicketDetails';
import { RejectTicket } from '../../components/pages/tickets/table/actionButtons/RejectTicket';
import {ConfirmContactTicket} from "../../components/pages/tickets/table/actionButtons/ConfirmContactTicket";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './ViewTicket.scss';

function ViewTicketComponent(props) {
  const { ticketId } = props.match.params;
  const [ ticket, setTicket ] = useState( null );

  useEffect( () => {
    getTicket( ticketId );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );

  const renderViewActionButtons = () => {
    const contactFormTicketTypes = [
      TICKET_TYPES.CONTACT_ISSUES, TICKET_TYPES.CONTACT_COMMERCIAL, TICKET_TYPES.CONTACT_OTHERS
    ]

    if (ticket && ticket.id) {
      if (ticket.type === TICKET_TYPES.DELETE_ORGANIZATION) {
        return (
          <>
            <ConfirmDeleteOrganizationTicket
              ticket={ticket}
              index={1}
              actionCallback={() => history.push( ROUTE_CLIENT_TICKETS )}
            />
            <RejectTicket
              ticket={ticket}
              index={1}
              actionCallback={() => history.push( ROUTE_CLIENT_TICKETS )}
            />
          </>
        )
      }

      if (contactFormTicketTypes.indexOf(ticket.type) !== -1) {
        return (
          <>
            <ConfirmContactTicket
              ticket={ticket}
              index={1}
              actionCallback={() => history.push( ROUTE_CLIENT_TICKETS )}
            />
            <RejectTicket
              ticket={ticket}
              index={1}
              actionCallback={() => history.push( ROUTE_CLIENT_TICKETS )}
            />
          </>
        )
      }
    }
  }

  /**
   * Get ticket details
   * @param {string} [ticketId]
   */
  const getTicket = (ticketId) => {
    if (! ACL.CLIENT.TICKETS.MANAGE.hasAccess()) {
      return;
    }

    getTicketDetailsApi( {
      ticketId: ticketId,
      notificationId: NOTIFICATION_VIEW_TICKET,
      pagination: {
        page_context: PAGE_CONTEXTS.TICKETS.LIST
      }
    } ).then( (response) => {
      if (response && response.data && response.data.id) {
        setTicket( response.data );
      }
    } );
  };

  return (
    <DashboardLayout
      className="ticket-detail-page"
      location={props.location}
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
    >
      <PageWorkspace className="ticket-detail-workspace">
        <PageHeader
          actions={renderViewActionButtons()}
          title={<FormattedMessage id="pages.tickets.title"/>}
        />
        <div className="ticket-detail-notifications">
          <Messages notificationId={NOTIFICATION_TICKETS_ACTIONS}/>
          <Messages notificationId={NOTIFICATION_VIEW_TICKET}/>
        </div>
        <PageSurface className="ticket-detail-surface">
          {! ACL.CLIENT.TICKETS.MANAGE.hasAccess() ? <NoRights/> : <TicketDetailsComponent
            location={props.location}
            ticket={ticket}
          />}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

export { ViewTicketComponent };
